import { render, staticRenderFns } from "./feedBack.vue?vue&type=template&id=139bbc43&scoped=true&"
import script from "./feedBack.vue?vue&type=script&lang=js&"
export * from "./feedBack.vue?vue&type=script&lang=js&"
import style0 from "./feedBack.vue?vue&type=style&index=0&id=139bbc43&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139bbc43",
  null
  
)

export default component.exports